<nz-select nzShowSearch *ngIf="DO && DO.length > 1" class="quest-input-width d-b" nzPlaceHolder="Choose"
  (ngModelChange)="findProposal/PolicyByNum($event)" [(ngModel)]="selectPolNum">
  <nz-option *ngFor="let item of DO" [nzLabel]="item?.proposalNum" [nzValue]="item?.proposalNum"></nz-option>
</nz-select>
<!-- {{!environment.production ? (selectedpolicy | json) : ''}} -->
<br>

<div class="title-emphasis">
  <!-- <i class="title-ico anticon anticon-file-protect"></i> -->
  <span nz-icon nzType="file-protect" nzTheme="outline" class="title-ico"></span>
  <div>
    <h4 class="p-0 m-0">{{selectedpolicy?.proposalDO?.baseProductCd || '' | technicalTranslate}}</h4>
    <span class="col-grey-dark"
      *ngIf="selectedpolicy?.proposalDO?.proposalNum">{{selectedpolicy?.proposalDO?.proposalNum || '' | translate}}</span>
    <span class="col-grey-dark"
      *ngIf="selectedpolicy?.proposalDO?.proposalNum == null">{{selectedpolicy?.proposalDO?.proposalNum || '' | translate}}</span>
  </div>
</div>

<!-- Summary -->
<div class="summary-container grid grid-3x grid-gap-20">
  <div>
    <span class="s-c-head" translate>Proposal/Policy No</span>
    <span *ngIf="selectedpolicy?.proposalDO?.proposalNum">{{selectedpolicy?.proposalDO?.proposalNum || '' | translate}}</span>
    <span
      *ngIf="selectedpolicy?.proposalDO?.proposalNum ==null">{{selectedpolicy?.proposalDO?.proposalNum || '' | translate}}</span>
  </div>
  <div>
    <span class="s-c-head" translate>Plan Option</span>
    <span>{{(selectedpolicy?.proposalDO?.productPlanOptionCd | technicalTranslate) || '-'}}</span>
  </div>
  <div>
    <span class="s-c-head" translate>Policy Type</span>
    <span>{{(selectedpolicy?.proposalDO?.baseProductTypeCd | technicalTranslate) || '-'}}</span>
  </div>
  <!-- Commented for metlife -->
  <!-- <div>
    <span class="s-c-head" translate>Product</span> {{selectedpolicy?.proposalDO?.baseProductCd || '' | translate}}
    <span *ngIf="selectedpolicy?.proposalDO?.baseProductCd ==null">-</span>
  </div>
  <div>
    <span class="s-c-head" translate>Plan</span> {{selectedpolicy?.proposalDO?.baseProductTypeCd || '' | translate}}
    <span *ngIf="selectedpolicy?.proposalDO?.baseProductTypeCd ==null">-</span>
  </div> -->

  <div>
    <span class="s-c-head" translate>Premium Status</span>
    <span *ngIf="selectedpolicy?.proposalDO?.premiumStatusCd">
      {{(selectedpolicy?.proposalDO?.premiumStatusCd | technicalTranslate) || ''}}</span>
    <span *ngIf="selectedpolicy?.proposalDO?.premiumStatusCd ==null">-</span>
  </div>
  <div>
    <span class="s-c-head" translate>Risk Commencement Date</span>
    <nz-badge class="d-b">{{getDateString(selectedpolicy?.proposalDO?.policyCommencementDt)}}</nz-badge>
  </div>
  <div>
    <span class="s-c-head" translate>Proposal/Policy Maturity Date</span>
    <nz-badge nzStatus="success">{{getDateString(selectedpolicy?.proposalDO?.policyExpiryDt)}} </nz-badge>
    <!-- <small class="d-b">(in 6 months)</small> -->
  </div>

  <div>
    <span class="s-c-head" translate>Issuance Date</span>
    <nz-badge *ngIf="selectedpolicy?.proposalDO?.policyIssueDt!=null">
      {{getDateString(selectedpolicy?.proposalDO?.policyIssueDt)}} </nz-badge>
    <nz-badge *ngIf="selectedpolicy?.proposalDO?.policyIssueDt==null">
      {{getDateString(selectedpolicy?.proposalDO?.policyCommencementDt)}} </nz-badge>
    <!-- <small class="d-b">(in 6 months)</small> -->
  </div>



  <!-- Below fields values are not binded -->
  <!-- <div>
    <span class="s-c-head" translate>Premium Paid Till Date</span>
    <span>{{getDateString(selectedpolicy?.proposalDO?.premPaidTillDt)}}</span>
  </div> -->

  <div>
    <span class="s-c-head" translate>Base Premium</span>
    <span>{{(selectedpolicy?.proposalDO?.baseAnnualPremium  | CurrencyFormatter : (selectedpolicy?.proposalDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)) || ''}}</span>
  </div>

  <div>
    <span class="s-c-head" translate>Premium With Tax</span>
    <span>{{(selectedpolicy?.proposalDO?.finalPremiumAmt  | CurrencyFormatter : (selectedpolicy?.proposalDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)) || ''}}</span>
  </div>

  <div *ngIf="false">
    <span class="s-c-head" translate>Payment Method</span>
    <span>{{(selectedpolicy?.proposalDO?.proposalPayments[0]?.paymentMethodCd | technicalTranslate) || ''}}</span>
  </div>

  <div>
    <span class="s-c-head" translate>Premium Frequency</span>
    <span>{{(selectedpolicy?.proposalDO?.paymentFrequencyCd | technicalTranslate) || ''}}</span>
  </div>

  <!-- TODO: Field Not found in ODS -->
  <div *ngIf="appMetadataHandler.entryViewModule == 'Claims'">
    <span class="s-c-head" translate>Sum Insured At Inception</span>
    <span>NOT FOUND ODS</span>
  </div>

  <div>
    <span class="s-c-head" translate>{{appMetadataHandler.SI_LABEL}}</span>
    <span>{{(selectedpolicy?.proposalDO?.sumInsured  | CurrencyFormatter : (selectedpolicy?.proposalDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)) || '' }}</span>
  </div>

  <!-- TODO: TO BE changed later -->
  <!-- <div>
    <span class="s-c-head" translate>Premium Paying Term</span>
    <span>{{selectedpolicy?.proposalDO?.indemnityPeriod || ''}}</span>
  </div> -->

  <div>
    <span class="s-c-head" translate>Proposal/Policy Term</span>
    <span>{{selectedpolicy?.proposalDO?.policyTerm || '' }}</span>
  </div>
  <div *ngIf="appMetadataHandler.entryViewModule == 'Claims'">
    <span class="s-c-head" translate>Medical At Proposal</span>
    <span>{{(selectedpolicy?.proposalDO?.medicalStatusCd | technicalTranslate) || ''}}</span>
  </div>

  <!-- <div>
    <span class="s-c-head" translate>UW Loading</span>
    <span>{{selectedpolicy?.proposalDO?.uwDecisionValue || '' | translate}}</span>
  </div> -->

  <!-- <div>
    <span class="s-c-head" translate>Proposal/Policy Status At Event</span>
    <span>{{(selectedpolicy?.proposalDO?.statusCd | technicalTranslate) || ''</span>
  </div> -->

  <!-- TODO: TO be change later -->
  <div>
    <span class="s-c-head" translate>Current Proposal/Policy Status</span>
    <span>{{(selectedpolicy?.proposalDO?.statusCd | technicalTranslate) || ''}}</span>
  </div>


  <!-- <div>
    <span class="s-c-head" translate>Joint Life</span>
    <span *ngIf="selectedpolicy?.proposalDO?.jointLifeFl == 1">Yes</span>
    <span *ngIf="selectedpolicy?.proposalDO?.jointLifeFl != 1">No</span>
  </div> -->

  <div *ngIf="appMetadataHandler.entryViewModule == 'Claims'">
    <span class="s-c-head" translate>Reinstatement Flag</span>
    <span *ngIf="selectedpolicy?.proposalDO?.reinstatementFl == 1">Yes</span>
    <span *ngIf="selectedpolicy?.proposalDO?.reinstatementFl != 1">No</span>
  </div>

  <div *ngIf="appMetadataHandler.entryViewModule == 'Claims'">
    <span class="s-c-head" translate>Reinstatement Date</span>

    <span>{{getDateString(selectedpolicy?.proposalDO?.reinstatementDt)}}</span>
  </div>

  <div *ngIf="appMetadataHandler.entryViewModule == 'Claims'">
    <span class="s-c-head" translate>Claims Propensity Score</span>
    <span>-</span>
  </div>

  <div *ngIf="appMetadataHandler.entryViewModule == 'Claims'">
    <span class="s-c-head" translate>Login Branch</span>
    <span>{{(selectedpolicy?.proposalDO?.agentCompanyBranchCd | technicalTranslate) || ''}} </span>

  </div>

  <div *ngIf="appMetadataHandler.entryViewModule == 'Claims'">
    <span class="s-c-head" translate>State</span>
    <span>{{(selectedpolicy?.proposalDO?.agentDivisionCd | technicalTranslate) || ''}}</span>
  </div>
  <div *ngIf="appMetadataHandler.entryViewModule == 'Claims'">
    <span class="s-c-head" translate>Sourcing Channel</span>
    <span>{{(selectedpolicy?.proposalDO?.agentSubDivisionCd | technicalTranslate) || ''}}</span>
  </div>

  <!-- <div *ngFor="let item of tempListToshow">
    <span class="s-c-head" translate>{{item?.Key}}</span> {{item?.value}}
    <span *ngIf="item?.value ==null || item?.value== '' ">-</span>
  </div> -->
</div>


<div>
  <h3 class="p-t-b-20 f-w-400 f-s-1r">Client Details</h3>
  <nz-table #smallTable nzSize="small" #clientTable [nzData]="selectedpolicy?.proposalDO?.proposalClients"
    [nzShowPagination]="false">
    <thead>
      <tr>
        <th translate>Client Number</th>
        <th translate>Client Name</th>
        <th translate>Role</th>
        <!-- <th translate>Relationship</th> -->
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of clientTable.data">
        <td>{{getClientNum(data,selectedpolicy?.proposalDO?.proposalNum)}}</td>
        <td><a
            (click)="getClientDOofSelectedClient(data)">{{getClientName(data,selectedpolicy?.proposalDO?.proposalNum)}}</a>
        </td>
        <td>{{(data?.roleCd | technicalTranslate) || '' }}</td>
        <!-- <td>{{(data?.relationCd | technicalTranslate) || ''}}</td> -->
      </tr>
    </tbody>
  </nz-table>
</div>

<div>
  <h3 class="p-t-b-20 f-w-400 f-s-1r">Additional Coverages</h3>
  <nz-table #smallTable nzSize="small" #coverageTable [nzData]="selectedpolicy?.proposalDO?.proposalCoverages"
    [nzShowPagination]="false">
    <thead>
      <tr>
        <th translate>Coverage</th>
        <!-- <th translate>Insured</th> -->
        <!-- <th translate>Component</th> -->
        <th translate>{{appMetadataHandler.SI_LABEL}}</th>
        <th translate>Premium</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let data of coverageTable.data">
        <ng-container *ngFor="let covIns of data.proposalCoverageInsureds">
          <tr *ngIf="data?.planTypeCd !='BASEPLAN' &&  data?.associationType =='MANDATORY'">
            <td>{{(data?.productCd  | technicalTranslate) || ''}} </td>
            <!-- <td>{{getClientName(covIns,selectedpolicy?.proposalDO?.proposalNum)}}</td> -->
            <!-- <td>{{(selectedpolicy?.proposalDO?.baseProductCd | technicalTranslate) || '-'}}</td> -->
            <td>{{data?.sumInsured  | CurrencyFormatter : (selectedpolicy?.proposalDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</td>
            <td>{{data?.baseAnnualPremium  | CurrencyFormatter : (selectedpolicy?.proposalDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</td>
          </tr>
        </ng-container>
        <tr *ngIf="data?.planTypeCd !='BASEPLAN' && data?.associationType =='OPTIONAL'">
          <td>{{(data?.productCd  | technicalTranslate) || ''}} </td>
          <!-- <td>{{getClientName(data?.policyCoverageInsuredList[0],selectedpolicy?.proposalDO?.proposalNum)}}</td> -->
          <!-- <td>{{(selectedpolicy?.proposalDO?.baseProductCd | technicalTranslate) || '-'}}</td> -->
          <td>{{data?.sumInsured  | CurrencyFormatter : (selectedpolicy?.proposalDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</td>
          <td>{{data?.baseAnnualPremium  | CurrencyFormatter : (selectedpolicy?.proposalDO?.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</td>
        </tr>
      </ng-container>
    </tbody>
  </nz-table>
</div>

<div *ngIf="selectedpolicy?.proposalDO?.proposalAgents && selectedpolicy?.proposalDO?.proposalAgents.length > 0">
  <h3 class="p-t-b-20 f-w-400 f-s-1r">Intermediary Details</h3>
  <nz-table #agentTable nzSize="small" [nzData]="selectedpolicy?.proposalDO?.proposalAgents"
    [nzShowPagination]="false">
    <thead>
      <tr>
        <th translate>Intermediary Code</th>
        <th translate>Intermediary Name</th>
        <th translate>Channel</th>
        <th translate>Commission Percentage</th>
        <!-- <th translate>Primary Intermediary</th> -->
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of agentTable.data">
        <td>{{data?.agentNum}}</td>
        <td>{{getAgentName(data.agentNum)}}</td>
        <td>{{getAgentChannel(data.agentNum) | technicalTranslate}}</td>
        <td>{{data?.commissionPercent || 0}}%</td>
        <!-- <td [class.inputs-are-disabled]="transactionState != 'proposal_DataEntry'">
          <label nz-checkbox [(ngModel)]="data.primaryFl"></label>
        </td> -->
      </tr>
    </tbody>
  </nz-table>
</div>



<div *ngIf="appMetadataHandler.entryViewModule == 'Claims'">
  <h3 class="p-t-b-20 f-w-400 f-s-1r">Re-insurer Details</h3>
  <nz-table #smallTable nzSize="small" #insureTable [nzData]="templreInsuredListToshow" [nzShowPagination]="false">
    <thead>
      <tr>
        <th translate>Re-insurer Name</th>
        <th translate>Sum Ceeded </th>
        <th translate>Retention amount</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="selectedpolicy?.proposalDO?.reinsurerCd">
        <td>{{(selectedpolicy?.proposalDO?.reinsurerCd | technicalTranslate) || ''}}</td>
        <td>{{(selectedpolicy?.proposalDO?.sumSeededAmt | technicalTranslate) || ''}} </td>
        <td>{{(selectedpolicy?.proposalDO?.retentionAmt | technicalTranslate) || ''}}</td>
      </tr>
    </tbody>
  </nz-table>
</div>



<div *ngIf="appMetadataHandler.entryViewModule == 'Claims'">
  <h3 class="p-t-b-20 f-w-400 f-s-1r">Fund Details</h3>
  <nz-table #smallTable nzSize="small" #fundTable [nzData]="selectedpolicy?.proposalDO?.policyFunds"
    [nzShowPagination]="false">
    <thead>
      <tr>
        <th translate>Fund Name</th>
        <th translate>No Of Unit</th>
        <th translate>Date</th>
        <th translate>Fund value</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of fundTable.data">
        <td>>{{data.fundName || '' | translate }}</td>
        <td>{{data.units}} </td>
        <td>{{getDateString(data.navDt)}} </td>
        <td>{{data.fundValue}} </td>
      </tr>
    </tbody>
  </nz-table>
</div>

<br>
<div *ngIf="appMetadataHandler.entryViewModule == 'Claims'" class="summary-container grid grid-3x grid-gap-20">
  <h3><a (click)="viewLADetails()">View LA Details</a></h3>
  <h3><a (click)="viewNotes()">View Notes</a></h3>
  <h3><a (click)="viewClaims()">View Policies For Agent</a></h3>
  <h3><a (click)="viewMedical()">Medicals</a></h3>


</div>



<div *ngIf="appMetadataHandler.entryViewModule == 'Claims'">
  <h3 class="p-t-b-20 f-w-400 f-s-1r">Documents</h3>
  <app-document-manager [requirements]="[]" [inputDataForEdit]="[]"
    [RequirementEntityGuid]="selectedpolicy?.proposalDO?.guid" [readonly]="true" [entity]="'policy'">
  </app-document-manager>
</div>


<nz-drawer [nzClosable]="true" [nzWidth]="390" [nzVisible]="profilePanelOpen" [nzPlacement]="'right'"
  nzTitle="Client Details" (nzOnClose)="profilePanel(0)">
  <ng-container *nzDrawerContent>
  <ng-container *ngIf="profilePanelOpen">
    <app-view-profile-summary [IO]="_IO" transactionState="transactionState" [clientDO]="selectedClientDO">
    </app-view-profile-summary>
  </ng-container>
  </ng-container>
</nz-drawer>


<nz-modal [(nzVisible)]="viewLaModal" nzTitle="LA Transaction" (nzOnCancel)="viewLaModal=false"
  (nzOnOk)="viewLaModal=false" nzOkText="Ok" nzWidth="820px" nzZIndex="100">
  <ng-container *nzModalContent>
  <div *ngIf="viewLaModal">
    <nz-table [nzShowPagination]="true" [nzData]="[1,2]" [nzScroll]="{ x: '820px' }">
      <thead>
        <tr>
          <th class="col-min-width">Batch Description</th>
          <th class="col-min-width">Batch Code</th>
          <th class="col-min-width">Date SUB</th>
          <th class="col-min-width">Proposal/Policy no</th>
          <th class="col-min-width">Effective Date</th>
          <th class="col-min-width">Sys Transaction Date</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of intimationMetaDataTable">
          <td class="col-min-width">{{data?.batch_DESCRIPTION}}</td>
          <td class="col-min-width">{{data?.batch_CODE}}</td>
          <td class="col-min-width">{{getDateString(data.date_SUB)}}</td>
          <td class="col-min-width">{{data?.policy_NO}}</td>
          <td class="col-min-width">{{getDateString(data.effective_DATE)}}</td>
          <td class="col-min-width">{{getDateString(data.system_TRANSACTION_DATE)}}</td>
        </tr>
      </tbody>
    </nz-table>
  </div>
  </ng-container>
</nz-modal>

<!-- Notes model -->
<nz-modal [(nzVisible)]="viewNotesModal" nzTitle="Notes Details" (nzOnCancel)="viewNotesModal=false"
  (nzOnOk)="viewNotesModal=false" nzOkText="Ok" nzWidth="820px" nzZIndex="100">
  <ng-container *nzModalContent>
  <b>Work In Progress</b>
</ng-container>
</nz-modal>

<!-- Claim model -->

<nz-modal [(nzVisible)]="viewClaimModal" nzTitle="Agent Proposal/Policy Details" (nzOnCancel)="viewClaimModal=false"
  (nzOnOk)="viewClaimModal=false" nzOkText="Ok" nzWidth="820px" nzZIndex="100">
  <ng-container *nzModalContent>
  <b>Work In Progress</b>
</ng-container>
</nz-modal>


<nz-modal [(nzVisible)]="viewMedicalModal" nzTitle="Medical Details" (nzOnCancel)="viewMedicalModal=false"
  (nzOnOk)="viewMedicalModal=false" nzOkText="Ok" nzWidth="820px" nzZIndex="100">
  <ng-container *nzModalContent>
  <b>Work In Progress</b>
</ng-container>
</nz-modal>